export default __webpack_public_path__ + "static/media/whatsapp.4e339df6.png";